import { ReactElement, memo } from 'react';
import { Typography, Link } from '@mui/material';

import { MultipleLinearProgressItem } from './types';

const MultipleLinearProgressLegendLabel = ({
  label,
  onClick,
}: Pick<MultipleLinearProgressItem, 'label' | 'onClick'>): ReactElement => {
  if (onClick) {
    return (
      <Link
        variant="body2"
        color="text.secondary"
        underline="hover"
        onClick={onClick}
        sx={{ cursor: 'pointer' }}
      >
        {label}
      </Link>
    );
  }

  return <Typography variant="body2">{label}</Typography>;
};

export default memo(MultipleLinearProgressLegendLabel);
